import { Component, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { OrderPreviewComponent } from '../order-preview/order-preview-component';
import { Order } from '../../interfaces/orders/order';
import { eOrderType } from '../../enums';

@Component({
    selector: 'lib-search-order-preview',
    templateUrl: './search-order-preview.component.html',
    styleUrls: ['./search-order-preview.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchOrderPreviewComponent extends OrderPreviewComponent implements OnInit {
  @Input() order!: Order;
  protected criteriaHeaderKey: string = 'common.labels.searchCriteria';

  ngOnInit(): void {
    if (this.order.orderTypeID === eOrderType.ultimateBeneficialOwnershipReport) {
      this.criteriaHeaderKey = 'searchOrderPreview.entityName';
    }
  }
}
